export const PrepareTimeArray = (s = '0:01', f = '23:45', step = 15) => {
  let start = s;
  let finish = f;
  let isReversed = false;

  if(s.split(':')[0] > f.split(':')[0]) {
    start = s;
    finish = '24:15';
    isReversed = true;
  }

  let res = [];
  let timePoints = [];

  let startSplit = start.split(':');
  let startHH = parseInt(startSplit[0]);
  let startMM = parseInt(startSplit[1]);

  let fin = finish;
  let finishSplit = fin.split(':');
  let finishHH = parseInt(finishSplit[0]);
  let finishMM = parseInt(finishSplit[1]);

  let i = 0;
  while (i < 60) {
    timePoints.push(i);
    i += step;
  }

  for (let j = startHH; j <= finishHH; j++) {
    let hh = j <= 12 ? j : j - 12;

    if (hh == 0)
      hh = 12;

    let ampm = j < 12 ? 'am' : 'pm'; 

    if(j == 24)
      ampm = 'am'

    timePoints.forEach(mm => {
      if (
        (j == startHH && mm < startMM) ||
        (j == finishHH && mm > finishMM)
      )
      return;

      res.push({
        name: `${hh}:${mm < 10 ? `0${mm}` : mm} ${ampm}`,
        value: `${j < 10 ? `0${j}` : j}:${mm < 10 ? `0${mm}` : mm}`
      });
    });
  }
  if(!isReversed)
    return res;
  else return res.concat(PrepareTimeArray('00:00', f));
}

export const FromAMPM = (str) => {
  if (!str.includes(' '))
    str = `${str.slice(0, -2)}:00 ${str.slice(str.length - 2)}`;

  const [time, modifier] = str.split(' ');

  let [hours, minutes] = time.split(':');

  if (hours == '12') {
    hours = '00';
  }

  if (hours.length == 1) {
    hours = `0${hours}`;
  }

  if (modifier == 'pm') {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
}

export const ToAMPM = (str) => {
  let [hours, minutes] = str.split(':');
  let hh = hours % 12 || 12;
  let ampm = (hours < 12 || hours === 24) ? 'am' : 'pm';

  return `${hh}:${minutes} ${ampm}`;
}

export const Years = (() => {
  let currentYear = new Date().getFullYear();
  const years = [];
  while (currentYear > 2000) {
    const prevYear = currentYear--;
    years.push({ name: prevYear, value: prevYear });
  }
  return years;
})();

export const UniqueId = (prefix) => {
  const date = new Date();
  const components = [
    prefix,
    date.getYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  ];

  return components.join("");
}